// extracted by mini-css-extract-plugin
export default {"wrapper":"mp-z","response":"np-z","error":"op-z","disabled":"pp-z","buttons":"qp-z","feedbackQuestionSection":"rp-z","yesNoWrapper":"sp-z"};